<template>
  <section>
    <h3>
      Disaster Names
    </h3>
    <b-button
      @click="create">
      <b-icon
        icon="plus">
      </b-icon>
      Create
    </b-button>
    <b-table
        :data="names"
        :columns="columns">
    </b-table>
  </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'DisasterNameManagement',
  data() {
    return {
      columns: [
        {
          field: 'code',
          label: 'Code',
          searchable: true,
        },
        {
          field: 'year',
          label: 'Year',
          searchable: true,
        },
        {
          field: 'name',
          label: 'Name',
          searchable: true,
        }
      ]
    }
  },
  mounted () {
    this.fetch()
  },
  computed: {
    ...mapGetters('DisasterName', ['names'])
  },
  methods: {
    ...mapActions('DisasterName', ['fetch']),
    create () {
      this.$router.push({
        name: 'DisasterNameManagement:Create'
      })
    }
  }
}
</script>
